import { jsx as c } from "react/jsx-runtime";
import "react";
const l = ({ name: t, size: o = 24, fill: s = 0, weight: a = 500, grade: n = 0, opticalSize: e = 48, className: i, ...r }) => /* @__PURE__ */ c(
  "span",
  {
    className: `material-symbols-sharp ${i || ""}`,
    style: { fontVariationSettings: `'FILL' ${s}, 'wght' ${a}, 'GRAD' ${n}, 'opsz' ${e}`, fontSize: o },
    "aria-hidden": "true",
    ...r,
    children: t
  }
), $ = l;
export {
  $ as default
};
